module.exports = __webpack_public_path__ + "static/media/Carosel HO 4.47348e87.svg";